import 'bootstrap/js/dist/modal';

// allow the link to the 'Charging Infrastructure Terminology' modal to coexist with any
// existing search params, using javascript, since this involves modifying the vue hash from rails
// without updating the rails-side parameters.
const showEvTermsLink = document.getElementById('historic-trends-modal-link');
if (showEvTermsLink) {
  showEvTermsLink.addEventListener('click', function (e) {
    e.preventDefault();
    // from rails, get the hash of the stations Vue app through the window attributes
    // eslint-disable-next-line no-unused-vars
    const [baseUrl, hash] = window.location.href.split('#');

    // get the current path and query params, as well as the modal parameter
    const [path, searchParams = ''] = (hash || '').split('?');
    const showEvTermsParam = showEvTermsLink.dataset.paramShowEvTerms;
    const newParams = new URLSearchParams(searchParams);

    // combine the modal param with existing params
    showEvTermsParam.split('&').forEach(pair => {
      const [key, value] = pair.split('=');
      newParams.set(key, value);
    });

    // create an updated hash and replace the old hash with it
    const newHash = `${path}?${newParams.toString()}`;
    window.location.hash = newHash;
  })
}
